export const AREA_ACTIVITY_OPTIONS = [
  { value: "barbearia", label: "Barbearia" },
  { value: "clinica", label: "Clínica" },
  { value: "consultorio", label: "Consultório" },
  { value: "estetica", label: "Estética" },
  { value: "imobiliaria", label: "Imobiliária" },
  { value: "salao_beleza", label: "Salão de Beleza" },
  { value: "tecnologia", label: "Tecnologia" },
];

export const PERSONALITY_OPTIONS = [
  "Atenciosa",
  "Calorosa",
  "Carinhosa",
  "Calma",
  "Divertida",
  "Empática",
  "Energética",
  "Paciente",
  "Positiva",
  "Profissional",
];

export const GENDER_OPTIONS = [
  { value: "feminino", label: "Feminino" },
  { value: "masculino", label: "Masculino" },
];

export const NEXT_STEP_OPIONS = [
  { value: "", label: "Nenhuma" },
  { value: "agendar_atendimento", label: "Agendar Atendimento" },
  { value: "cancelar_atendimento", label: "Cancelar Atendimento" },
  { value: "reagendar_atendimento", label: "Reagendar Atendimento" },
  { value: "consulta_atendimento", label: "Consultar Atendimentos" },
  { value: "coletar_dados", label: "Coletar Dados" },
  {
    value: "verificar_disponibilidade",
    label: "Verificar Disponibilidade",
  },
  { value: "capturar_nome", label: "Capturar Nome" },
  { value: "identificar_necessidade", label: "Identificar Necessidade" },
];

export const MICRO_INTERACTIONS = {
  conectores: {
    label: "Conectores Naturais",
    defaultValue: "",
    placeholder:
      '"Olha só...", "Opa...", "Então...", "Ah, e uma coisa importante...", "Antes que eu esqueça..."',
  },
  validacao: {
    label: "Validação Emocional",
    defaultValue: "",
    placeholder:
      '"Entendo perfeitamente!", "Imagino como deve ser chato...", "Que bacana!", "Sei como é importante isso para você..."',
  },
  celebracao: {
    label: "Celebração",
    defaultValue: "",
    placeholder:
      '"Perfeito!", "Maravilha!", "Oba!", "Que escolha bacana!", "Pronto!"',
  },
  upsell: {
    label: "Upsell Natural",
    defaultValue: "",
    placeholder:
      'exemplo: "Vale muito a pena!", "É um investimento na sua saúde!", "Fica muito mais completo assim!", "Por só R$30 a mais..."',
  },
  emojis: {
    label: "Emojis Estratégicos",
    defaultValue: `- 😊🥰😄 - Acolhimento e estados positivos
- 🤔💭 - Demonstrar reflexão
- 🎯✅ - Confirmações e acertos
- 📅⏰ - Relacionados a tempo
- 💙❤️ - Demonstrar carinho genuíno
- ✨🌟 - Destacar algo especial
- 🎉🥳 - Celebrar sucessos
- 👁️🤓 - Relacionados a lentes de contato
- 🧑‍⚕️ - Profissional de saúde`,
    placeholder: "",
  },
  mantra: {
    label: "Mantra para Cada Resposta",
    defaultValue: "",
    placeholder:
      '"Como eu responderia se fosse minha melhor amiga perguntando sobre cuidados com a visão?" 💙✨',
  },
};

export const CONVERSATION_TEMPLATES = {
  basic: {
    name: "Template Básico",
    description: "Para negócios que querem um atendimento simples e direto",
    icon: "💬",
    steps: [
      {
        key: "greeting",
        label: "Cumprimentar o Cliente",
        description: "Como o agente vai cumprimentar cada pessoa que chegar",
        icon: "👋",
        placeholder:
          "Exemplo: Oi! Tudo bem? Eu sou a Maria, como posso te ajudar hoje? 😊",
        aiPrompt:
          "Crie uma saudação calorosa e amigável para o agente cumprimentar clientes",
      },
      {
        key: "needIdentification",
        label: "Descobrir o que a Pessoa Quer",
        description: "Como perguntar o que o cliente está procurando",
        icon: "🤔",
        placeholder:
          "Exemplo: O que você está procurando hoje? Em que posso te ajudar?",
        aiPrompt:
          "Crie perguntas para descobrir a necessidade do cliente de forma natural",
      },
      {
        key: "presentation",
        label: "Explicar Como Você Pode Ajudar",
        description: "Como apresentar seus produtos ou serviços",
        icon: "💡",
        placeholder:
          "Exemplo: Perfeito! Temos exatamente o que você precisa...",
        aiPrompt:
          "Crie uma apresentação dos produtos/serviços de forma persuasiva",
      },
      {
        key: "closing",
        label: "Finalizar o Atendimento",
        description: "Como encerrar a conversa e definir próximos passos",
        icon: "🎯",
        placeholder:
          "Exemplo: Quer que eu agende para você? Ou tem alguma dúvida?",
        aiPrompt: "Crie um fechamento que direcione para a próxima ação",
      },
    ],
  },
  sales: {
    name: "Template para Vendas",
    description: "Para negócios focados em vender produtos ou serviços",
    icon: "🛒",
    steps: [
      {
        key: "greeting",
        label: "Cumprimentar e Gerar Interesse",
        description: "Saudação que desperta curiosidade",
        icon: "🎯",
        placeholder:
          "Exemplo: Oi! Você vai adorar nossas novidades! Como posso te chamar?",
        aiPrompt:
          "Crie uma saudação que gere interesse e desperte curiosidade para vendas",
      },
      {
        key: "needIdentification",
        label: "Qualificar o Cliente",
        description: "Descobrir o perfil e necessidade específica",
        icon: "🔍",
        placeholder:
          "Exemplo: Para eu te mostrar a opção perfeita, me conta: você está procurando o quê exatamente?",
        aiPrompt:
          "Crie perguntas de qualificação para entender o perfil do cliente",
      },
      {
        key: "presentation",
        label: "Apresentar Soluções",
        description: "Mostrar produtos focando nos benefícios",
        icon: "✨",
        placeholder:
          "Exemplo: Baseado no que você me contou, tenho a solução perfeita! Olha só...",
        aiPrompt:
          "Crie uma apresentação de produtos focada em benefícios e resultados",
      },
      {
        key: "upsell",
        label: "Oferecer Complementos",
        description: "Sugerir produtos ou serviços adicionais",
        icon: "⬆️",
        placeholder:
          "Exemplo: Ah, e tem uma coisa que fica perfeita com isso...",
        aiPrompt: "Crie ofertas de upsell de forma natural e convincente",
      },
      {
        key: "closing",
        label: "Fechar a Venda",
        description: "Conduzir para finalização da compra",
        icon: "💳",
        placeholder: "Exemplo: Pronto para finalizar? Aceito PIX, cartão...",
        aiPrompt: "Crie um fechamento de vendas eficaz e direto",
      },
    ],
  },
  appointment: {
    name: "Template para Agendamentos",
    description: "Para consultórios, clínicas e prestadores de serviço",
    icon: "📅",
    steps: [
      {
        key: "greeting",
        label: "Recepcionar o Cliente",
        description: "Saudação profissional e acolhedora",
        icon: "🏥",
        placeholder:
          "Exemplo: Oi! Eu sou a Amanda do consultório. Como posso te chamar?",
        aiPrompt:
          "Crie uma recepção profissional mas calorosa para consultório/clínica",
      },
      {
        key: "needIdentification",
        label: "Identificar a Necessidade",
        description: "Descobrir que tipo de atendimento precisa",
        icon: "🔍",
        placeholder:
          "Exemplo: Me conta, o que te trouxe aqui hoje? Que tipo de atendimento você precisa?",
        aiPrompt:
          "Crie perguntas para identificar o tipo de atendimento ou serviço necessário",
      },
      {
        key: "availability",
        label: "Verificar Disponibilidade",
        description: "atendimento horários disponíveis",
        icon: "🕒",
        placeholder:
          "Exemplo: Perfeito! Temos horários disponíveis. Qual período prefere: manhã ou tarde?",
        aiPrompt:
          "Crie o processo de verificação de disponibilidade de horários",
      },
      {
        key: "dataCollection",
        label: "Coletar Dados do Cliente",
        description: "Solicitar informações necessárias para agendamento",
        icon: "📋",
        placeholder:
          "Exemplo: Para finalizar o agendamento, preciso do seu nome e data de nascimento.",
        aiPrompt:
          "Crie o processo de coleta de dados necessários para agendamento",
      },
      {
        key: "confirmation",
        label: "Confirmar Agendamento",
        description: "Finalizar e confirmar a atendimento",
        icon: "✅",
        placeholder:
          "Exemplo: Pronto! Sua atendimento está marcada para [data] às [hora]. Te esperamos!",
        aiPrompt: "Crie uma confirmação de agendamento clara e acolhedora",
      },
    ],
  },
};

export const AVAILABLE_FUNCTIONS = [
  {
    id: "agendar_atendimento",
    name: "Agendar Atendimento",
    description: "Agenda um atendimento com as informações necessárias.",
    icon: "📅",
    hasResponse: true,
    allowCustomFields: true,
    fields: [
      {
        id: "nome_cliente",
        label: "Nome do Cliente",
        type: "string",
        description: "Nome completo do cliente",
      },
      {
        id: "data_nascimento",
        label: "Data de Nascimento",
        type: "string",
        description: "Data no formato DD-MM-YYYY",
      },
      {
        id: "cpf",
        label: "CPF",
        type: "string",
        description: "CPF do paciente (apenas números)",
      },
      {
        id: "data",
        label: "Data do Agendamento",
        type: "string",
        description: "Data no formato DD-MM-YYYY",
      },
      {
        id: "horario",
        label: "Horário",
        type: "string",
        description: "Horário no formato HH:MM",
      },
      {
        id: "tipo",
        label: "Tipo de Atendimento",
        type: "string",
        description: "Tipo de atendimento escolhida",
      },
      {
        id: "valor",
        label: "Valor",
        type: "string",
        description: "Valor da atendimento",
      },
      {
        id: "pagamento",
        label: "Status do Pagamento",
        type: "enum",
        options: ["pago", "pendente"],
        description: "Situação do pagamento",
      },
      {
        id: "motivo",
        label: "Motivo",
        type: "string",
        description: "Motivo do agendamento",
      },
      {
        id: "origem",
        label: "Origem",
        type: "enum",
        options: ["cliente_direto", "trafego", "midias_sociais"],
        description: "Como chegou até nós",
      },
      {
        id: "observacoes",
        label: "Observações",
        type: "string",
        description: "Informações adicionais",
      },
    ],
  },
  {
    id: "cancelar_atendimento",
    name: "Cancelar Atendimento",
    description: "Cancela agendamentos existentes",
    icon: "❌",
    hasResponse: true,
    allowCustomFields: true,
    fields: [
      {
        id: "confirmacao",
        label: "Confirmação",
        type: "boolean",
        description: "Cliente confirmou o cancelamento",
      },
      {
        id: "agendamento_id",
        label: "ID do Agendamento",
        type: "integer",
        description: "Identificador do agendamento",
      },
      {
        id: "motivo_cancelamento",
        label: "Motivo do Cancelamento",
        type: "enum",
        options: [
          "transporte",
          "financeiro",
          "opcao_melhor",
          "doenca",
          "outro",
        ],
        description: "Razão do cancelamento",
      },
      {
        id: "outro_motivo",
        label: "Outro Motivo",
        type: "string",
        description: "Detalhes quando motivo é 'outro'",
      },
      {
        id: "mensagem_resposta",
        label: "Mensagem de Resposta",
        type: "string",
        description: "Mensagem para o cliente",
      },
    ],
  },
  {
    id: "reagendar_atendimento",
    name: "Reagendar Atendimento",
    description: "Remarca agendamentos existentes",
    icon: "🔄",
    hasResponse: true,
    allowCustomFields: true,
    fields: [
      {
        id: "mensagem_resposta",
        label: "Mensagem de Resposta",
        type: "string",
        description: "Mensagem automática para o cliente",
      },
    ],
  },
  {
    id: "consultar_atendimento",
    name: "Consultar Atendimentos",
    description: "Consulta agendamentos existentes",
    icon: "🔎",
    hasResponse: false,
    allowCustomFields: false,
    fields: [],
  },
  {
    id: "verificar_disponibilidade",
    name: "Verificar Disponibilidade",
    description: "atendimento horários disponíveis",
    icon: "🔍",
    hasResponse: false,
    allowCustomFields: false,
    fields: [
      {
        id: "opcao_disponivel",
        label: "Opção Disponível",
        type: "string",
        description: "Ex: 'segunda_tarde', 'quinta_manha'",
      },
      {
        id: "tipo_atendimento_id",
        label: "ID Tipo Atendimento",
        type: "integer",
        description: "ID do tipo de atendimento",
      },
      {
        id: "dia_preferencia",
        label: "Dia de Preferência",
        type: "string",
        description: "Ex: 'segunda', 'amanhã', 'hoje'",
      },
      {
        id: "turno_preferencia",
        label: "Turno de Preferência",
        type: "string",
        description: "Ex: 'manha', 'tarde', 'noite'",
      },
    ],
  },

  {
    id: "coletar_dados",
    name: "Coletar Dados",
    description: "Coleta informações dos clientes",
    icon: "📊",
    hasResponse: true,
    allowCustomFields: true,
    fields: [
      {
        id: "nome",
        label: "Nome",
        type: "string",
        description: "Nome do lead",
      },
      {
        id: "telefone",
        label: "Telefone",
        type: "string",
        description: "Telefone do lead",
      },
      {
        id: "cpf",
        label: "CPF",
        type: "string",
        description: "CPF do lead",
      },
      {
        id: "data_nascimento",
        label: "Data de nascimento",
        type: "string",
        description: "Data de nascimento do lead",
      }
    ],
  },
  {
    id: "processar_confirmacao_agendamento",
    name: "Processar Confirmação",
    description: "Processa confirmação de presença",
    icon: "✅",
    hasResponse: true,
    allowCustomFields: true,
    fields: [
      {
        id: "confirmacao_presenca",
        label: "Confirmação de Presença",
        type: "enum",
        options: ["confirmado", "cancelar", "reagendar", "duvida"],
        description: "Resposta do cliente",
      },
      {
        id: "motivo",
        label: "Motivo",
        type: "string",
        description: "Detalhes adicionais",
      },
    ],
  },
  {
    id: "processar_feedback_cliente",
    name: "Processar Feedback",
    description: "Processa avaliação do cliente",
    icon: "⭐",
    hasResponse: true,
    allowCustomFields: true,
    fields: [
      {
        id: "avaliacao_numerica",
        label: "Nota (1-5)",
        type: "integer",
        description: "Avaliação numérica de 1 a 5",
      },
      {
        id: "sentimento",
        label: "Sentimento",
        type: "enum",
        options: ["positivo", "neutro", "negativo"],
        description: "Sentimento geral",
      },
      {
        id: "categoria_feedback",
        label: "Categoria",
        type: "enum",
        options: [
          "atendimento",
          "qualidade",
          "preco",
          "pontualidade",
          "ambiente",
          "outro",
        ],
        description: "Tipo de feedback",
      },
      {
        id: "texto_feedback",
        label: "Texto do Feedback",
        type: "string",
        description: "Feedback original do cliente",
      },
    ],
  },
];
